'use client';

import { ReleaseNoteDemo } from 'database';
import { createContext, ReactNode, useContext } from 'react';

export interface ReleaseNoteDemoProps {
  // The section the demo lives in, so what the reader does there is counted.
  sectionId: string;
}

export type ReleaseNoteDemoComponents = Partial<
  Record<ReleaseNoteDemo, (props: ReleaseNoteDemoProps) => JSX.Element>
>;

// The live pieces a note can embed, provided by the app that has them. With
// no provider a demo section shows a placeholder: the backoffice preview has
// no team to play with.
const ReleaseNoteDemosContext = createContext<ReleaseNoteDemoComponents>({});

export const ReleaseNoteDemosProvider = ({
  demos,
  children,
}: {
  demos: ReleaseNoteDemoComponents;
  children: ReactNode;
}) => (
  <ReleaseNoteDemosContext.Provider value={demos}>
    {children}
  </ReleaseNoteDemosContext.Provider>
);

export const useReleaseNoteDemo = (demo: ReleaseNoteDemo) =>
  useContext(ReleaseNoteDemosContext)[demo];
